import { MilestoneToBeBilled } from '@/services/billing/types/billing.type';
import moment from 'moment';
import { ChoicesOrderItemTypeForBilling } from '../../orders/types';
export const groupMilestonesBySubAndOrderType = (milestones: MilestoneToBeBilled[]) => {
  const groupedMilestones: { [key: string]: MilestoneToBeBilled[] } = {};

  milestones.forEach((milestone) => {
    const subscription = milestone.orderItem.subscription;
    const orderType =
      milestone.orderItem.orderItemType || ChoicesOrderItemTypeForBilling.billingCloud;
    const key = `${subscription}-${orderType}`;
    if (!groupedMilestones[key]) {
      groupedMilestones[key] = [];
    }

    groupedMilestones[key].push(milestone);
  });

  return Object.keys(groupedMilestones)
    .sort()
    .map((key) => ({
      key,
      milestones: groupedMilestones[key],
    }));
};

export const groupMilestonesByMonth = (milestones: MilestoneToBeBilled[]) => {
  const groupedMilestones: { [key: string]: MilestoneToBeBilled[] } = {};

  milestones.forEach((milestone) => {
    const groupKey = moment(milestone.paymentDate).utc().format('YYYY-MM');

    if (!groupedMilestones[groupKey]) {
      groupedMilestones[groupKey] = [];
    }

    groupedMilestones[groupKey].push(milestone);
  });

  return Object.keys(groupedMilestones)
    .sort()
    .map((yearMonth) => ({
      yearMonth,
      milestones: groupedMilestones[yearMonth],
    }));
};
